export var elementMutatorFactory = function (modifyElement) { return function (el) {
    modifyElement(el);
}; };
//# sourceMappingURL=element-mutator.js.map